import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { authApi } from "../services/auth";
import "./LoginPage.css";
import { t } from "../i18n";
import { T } from "../i18n/T";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  // The server says whether an account uses that email; we tell the talent
  // instead of claiming a link was sent to nobody.
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const isNative = Capacitor.isNativePlatform();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setNotFound(false);
    setSubmitting(true);
    try {
      // client:"app" tags the emailed reset link (?from=app) so the web reset
      // page tells the talent to come back to the app afterward.
      const res = await authApi.forgotPassword(email, isNative ? "app" : "web");
      if (res?.accountFound === false) setNotFound(true);
      else setSent(true);
    } catch {
      setError(t("forgotPasswordPage.somethingWentWrongSending"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-inner">
        {sent ? (
          <>
            <h1 className="login-hero-title">{t("forgotPasswordPage.checkYourEmail")}</h1>
            <p className="login-hero-tagline">
              <T k="forgotPasswordPage.resetLinkSentTo" vars={{ email }} tags={{ 0: (c) => <strong>{c}</strong> }} />
            </p>
            <p style={{ textAlign: "center", marginTop: "1.5rem" }}>
              <Link to="/login" className="login-link">
                {t("forgotPasswordPage.backToSignIn")}
              </Link>
            </p>
          </>
        ) : (
          <>
            <h1 className="login-hero-title">{t("forgotPasswordPage.resetPassword")}</h1>
            <p className="login-hero-tagline">
              {t("forgotPasswordPage.worksForGoogleAnd")}
            </p>
            {error && <p className="login-error">{error}</p>}
            {notFound && (
              <p className="login-error" role="status">
                <T k="forgotPasswordPage.noAccountUsesThat" tags={{ 0: (c) => <Link to="/register" className="login-link">{c}</Link> }} />
              </p>
            )}
            <form onSubmit={handleSubmit} className="login-form">
              <div className="input-wrapper">
                <input
                  type="email"
                  placeholder={t("forgotPasswordPage.email")}
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setNotFound(false); }}
                  required
                  autoFocus
                  className="login-input"
                />
              </div>
              <button
                type="submit"
                className="login-button"
                disabled={submitting}
              >
                {submitting ? t("forgotPasswordPage.sending") : t("forgotPasswordPage.sendResetLink")}
              </button>
            </form>
            <p style={{ textAlign: "center", marginTop: "1.25rem" }}>
              <Link to="/login" className="login-link">
                {t("forgotPasswordPage.backToSignIn")}
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
